var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuidesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.6673H2.66667C2.29848 14.6673 2 14.3689 2 14.0007V2.00065C2 1.63246 2.29848 1.33398 2.66667 1.33398H13.3333C13.7015 1.33398 14 1.63246 14 2.00065V14.0007C14 14.3689 13.7015 14.6673 13.3333 14.6673ZM12.6667 13.334V2.66732H3.33333V13.334H12.6667ZM4.66667 4.00065H7.33333V6.66732H4.66667V4.00065ZM4.66667 8.00065H11.3333V9.33398H4.66667V8.00065ZM4.66667 10.6673H11.3333V12.0007H4.66667V10.6673ZM8.66667 4.66732H11.3333V6.00065H8.66667V4.66732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesIcon);
export default __webpack_public_path__ + "static/media/guides-icon.d2ce388be1bf7bc16292f32f05d8a685.svg";
export { ForwardRef as ReactComponent };